import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  deleteDoc,
  setDoc,
  doc,
  onSnapshot,
  updateDoc,
  writeBatch,
} from "firebase/firestore";

const MenuManager = () => {
  const [menus, setMenus] = useState([]);

  const [newMenuName, setNewMenuName] = useState("");
  const [newMenuSlug, setNewMenuSlug] = useState("");
  const [newSubNames, setNewSubNames] = useState("");
  const [newSubSlugs, setNewSubSlugs] = useState("");

  const [editingId, setEditingId] = useState(null);

  const [editName, setEditName] = useState("");
  const [editSlug, setEditSlug] = useState("");
  const [editSubNames, setEditSubNames] = useState("");
  const [editSubSlugs, setEditSubSlugs] = useState("");
  const [hoveredBtn, setHoveredBtn] = useState("");

  useEffect(() => {
    const unsubscribe = onSnapshot(
      collection(db, "categories"),
      (snapshot) => {
        const data = snapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .sort((a, b) => Number(a.order || 0) - Number(b.order || 0));

        setMenus(data);
      }
    );

    return () => unsubscribe();
  }, []);

  const slugify = (text) => {
    return (text || "")
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w-]+/g, "")
      .replace(/--+/g, "-");
  };

  const generateShortId = () =>
    Math.floor(10000 + Math.random() * 90000).toString();

  const addMenu = async () => {
    if (!newMenuName.trim()) return;

    const nextOrder =
      menus.length > 0
        ? Math.max(...menus.map((m) => Number(m.order || 0))) + 1
        : 1;

    const subcategories = newSubNames
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const subcategorySlugs = newSubSlugs
      .split(",")
      .map((s) => slugify(s))
      .filter(Boolean);

    await setDoc(doc(db, "categories", generateShortId()), {
      name: newMenuName.trim(),
      slug: newMenuSlug.trim()
        ? slugify(newMenuSlug)
        : slugify(newMenuName),

      order: nextOrder,

      subcategories,
      subcategorySlugs,
    });

    setNewMenuName("");
    setNewMenuSlug("");
    setNewSubNames("");
    setNewSubSlugs("");

    alert("ক্যাটাগরি সংরক্ষিত হয়েছে");
  };
    const updateMenu = async (id) => {
    if (!editName.trim()) return;

    const subcategories = editSubNames
      .split(",")
      .map((s) => s.trim())
      .filter(Boolean);

    const subcategorySlugs = editSubSlugs
      .split(",")
      .map((s) => slugify(s))
      .filter(Boolean);

    try {
      await updateDoc(doc(db, "categories", id), {
        name: editName.trim(),
        slug: editSlug.trim()
          ? slugify(editSlug)
          : slugify(editName),

        subcategories,
        subcategorySlugs,
      });

      setEditingId(null);

      alert("আপডেট সফল হয়েছে!");
    } catch (err) {
      console.error(err);
      alert("আপডেট করতে সমস্যা হয়েছে!");
    }
  };

  const updateSerial = async (id, newOrder) => {
    const newOrderNum = parseInt(newOrder);

    if (
      isNaN(newOrderNum) ||
      newOrderNum < 1 ||
      newOrderNum > menus.length
    )
      return;

    const current = menus.find((m) => m.id === id);

    if (!current || current.order === newOrderNum) return;

    let temp = menus.filter((m) => m.id !== id);

    temp.splice(newOrderNum - 1, 0, current);

    temp = temp.map((m, index) => ({
      ...m,
      order: index + 1,
    }));

    const batch = writeBatch(db);

    temp.forEach((m) => {
      batch.update(doc(db, "categories", m.id), {
        order: m.order,
      });
    });

    await batch.commit();
  };

  return (
    <div style={{ padding: 20 }}>

      <h3>ক্যাটাগরি ম্যানেজমেন্ট</h3>

      <div
        style={{
          background: "#f5f5f5",
          padding: 15,
          marginBottom: 20,
          borderRadius: 6,
        }}
      >

        <input
          placeholder="ক্যাটাগরির নাম"
          value={newMenuName}
          onChange={(e) => setNewMenuName(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginBottom: 10,
          }}
        />

        <input
          placeholder="Menu Slug"
          value={newMenuSlug}
          onChange={(e) => setNewMenuSlug(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginBottom: 10,
          }}
        />

        <input
          placeholder="Sub Menu (কমা দিয়ে)"
          value={newSubNames}
          onChange={(e) => setNewSubNames(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginBottom: 10,
          }}
        />

        <input
          placeholder="Sub Menu Slug (কমা দিয়ে)"
          value={newSubSlugs}
          onChange={(e) => setNewSubSlugs(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            marginBottom: 10,
          }}
        />

        <button
          onClick={addMenu}
          style={{
            padding: "10px 18px",
            background: "#8b0000",
            color: "#fff",
            border: "none",
            cursor: "pointer",
            borderRadius: 5,
          }}
        >
          সংরক্ষণ করুন
        </button>

      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ background: "#333", color: "#fff" }}>
            <th>নাম</th>
            <th>Slug</th>
            <th>Sub Menu</th>
            <th>Sub Menu Slug</th>
            <th>Serial</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
		{menus.map((menu, index) => (
  <tr
    key={menu.id}
    style={{
      borderBottom: "1px solid #ddd",
      background: index % 2 === 0 ? "#fff" : "#f9f9f9",
    }}
  >
    <td style={{ padding: 10 }}>
      {editingId === menu.id ? (
        <input
          value={editName}
          onChange={(e) => setEditName(e.target.value)}
        />
      ) : (
        menu.name
      )}
    </td>

    <td style={{ padding: 10 }}>
      {editingId === menu.id ? (
        <input
          value={editSlug}
          onChange={(e) => setEditSlug(e.target.value)}
        />
      ) : (
        menu.slug
      )}
    </td>

    <td style={{ padding: 10 }}>
      {editingId === menu.id ? (
        <input
          style={{ width: "95%" }}
          value={editSubNames}
          onChange={(e) => setEditSubNames(e.target.value)}
          placeholder="বিএনপি,এনসিপি"
        />
      ) : (
        Array.isArray(menu.subcategories)
          ? menu.subcategories.join(", ")
          : ""
      )}
    </td>

    <td style={{ padding: 10 }}>
      {editingId === menu.id ? (
        <input
          style={{ width: "95%" }}
          value={editSubSlugs}
          onChange={(e) => setEditSubSlugs(e.target.value)}
          placeholder="bnp,ncp"
        />
      ) : (
        Array.isArray(menu.subcategorySlugs)
          ? menu.subcategorySlugs.join(", ")
          : ""
      )}
    </td>

    <td style={{ textAlign: "center" }}>
      <input
        type="number"
        value={menu.order}
        style={{ width: 55, textAlign: "center" }}
        onChange={(e) =>
          setMenus(
            menus.map((m) =>
              m.id === menu.id
                ? { ...m, order: e.target.value }
                : m
            )
          )
        }
        onBlur={(e) => updateSerial(menu.id, e.target.value)}
      />
    </td>

    <td style={{ textAlign: "right", padding: 10 }}>
      {editingId === menu.id ? (
        <button
          onClick={() => updateMenu(menu.id)}
        >
          Update
        </button>
      ) : (
       <div
  style={{
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "0px",
  }}
>
         <button
  onMouseEnter={() => setHoveredBtn(`edit-${menu.id}`)}
  onMouseLeave={() => setHoveredBtn("")}
  style={{
    padding: "8px 12px",
    cursor: "pointer",
    borderRadius: "4px",
    border: "1px solid #999",
    background:
      hoveredBtn === `edit-${menu.id}` ? "#007bff" : "#fff",
    color:
      hoveredBtn === `edit-${menu.id}` ? "#fff" : "#000",
    transition: "0.3s"
  }}
  onClick={() => {
    setEditingId(menu.id);

    setEditName(menu.name || "");
    setEditSlug(menu.slug || "");

    setEditSubNames(
      Array.isArray(menu.subcategories)
        ? menu.subcategories.join(",")
        : ""
    );

    setEditSubSlugs(
      Array.isArray(menu.subcategorySlugs)
        ? menu.subcategorySlugs.join(",")
        : ""
    );
  }}
>
  Edit
</button>

         <button
  onMouseEnter={() => setHoveredBtn(`delete-${menu.id}`)}
  onMouseLeave={() => setHoveredBtn("")}
  style={{
    background:
      hoveredBtn === `delete-${menu.id}`
        ? "#8b0000"
        : "#ff4d4f",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    cursor: "pointer",
    borderRadius: "4px",
    transition: "0.3s"
  }}
  onClick={async () => {
    if (window.confirm("আপনি কি নিশ্চিত?")) {
      await deleteDoc(doc(db, "categories", menu.id));
    }
  }}
>
  Delete
</button>
        </div>
      )}
    </td>
  </tr>
))}
        </tbody>
      </table>
    </div>
  );
};

export default MenuManager;